import React from 'react';
import { EditableInfo } from "@icoach/components";

const SpecialConditionBox = ({ className, specialCondition, onEdit }) => {
    return (
        <EditableInfo label="聯繫注意與偏好" onEdit={onEdit} className={className} isMultiline>
            {specialCondition}
        </EditableInfo>
    );
};

export default SpecialConditionBox;
